import React from 'react';
import {connect} from 'react-redux';
import {importFunctionProcedureCategories,updateIWPPWorkflowApprovers,deleteIWPPApproverStep,importFunctionProcedures,fetchProjects,selectFunction,selectGbu,selectProject,editFunctions,saveProjectFunctions,addProject,updateGbuWorkflowApprovers,updateProjectWorkflowApprovers,updateProject} from '../../reduxActions/ProjectActions';
import { showSnackBarMessage } from '../../reduxActions/AppInfoActions';
import WebServices from '../../WebServices';
import _ from 'lodash';

const ProjectsContext = React.createContext({});

class ProjectsStore extends React.Component {
    state = {
       addingProjectDialogOpen:false,
       projectWorkflowDialogOpen : false,
       editingIWPPApprovers : false,
       iwppApproverStepToDelete : null,
       confirmGbuApproversDialogOpen : false,
       onConfirmGbuApprovers : null,
       confirmGbuApproversSubtitle : "",
       changeDisplayFunctionList:false,
         projectCustomNameDialogOpen : false,
        lastAutoOpenedFunctionId: null,
        pendingFunctionSelections: null,
        workflowHasPendingChanges: false,
        functionsMissingPrimary: {},
        projectWorkflowActiveTab: 0,
        projectWorkflowProceduresTab: 'Enterprise',

    };

    pendingPrimaryChecks = {};
    assignedFunctionsSignature = null;

    constructor(props) {
        super(props);
        this._isMounted = false;
    }

    displayWorkflowDialog = () => this.setState({projectWorkflowDialogOpen:true});
    closeWorkflowDialog = () => this.setState({projectWorkflowDialogOpen:false});

    displayAddProjectDialog = () => this.setState({addingProjectDialogOpen:true});
    closeAddProjectDialog = () => this.setState({addingProjectDialogOpen:false});
    editIWPPApprovers = (editingIWPPApprovers) => this.setState({editingIWPPApprovers});
    confirmDeleteOfIWPPAprroverStep = (iwppApproverStepToDelete) => this.setState({iwppApproverStepToDelete});

    closeConfirmGbuApproversDialog = () => this.setState({confirmGbuApproversDialogOpen:false,onConfirmGbuApprovers:null});
    
    displayFunctionList = changeDisplayFunctionList => this.setState({changeDisplayFunctionList}); 

    displayProjectCustomNameDialog = () => this.setState({projectCustomNameDialogOpen:true});
    closeProjectCustomNameDialog = () => this.setState({projectCustomNameDialogOpen:false});

    setPendingFunctionSelections = (pendingFunctionSelections) => this.setState({ pendingFunctionSelections });
    clearPendingFunctionSelections = () => this.setState({ pendingFunctionSelections: null });
    setWorkflowPendingChanges = (workflowHasPendingChanges) => {
        this.setState((prevState) =>
            prevState.workflowHasPendingChanges === workflowHasPendingChanges
                ? null
                : { workflowHasPendingChanges }
        );
    }

    setProjectWorkflowActiveTab = (projectWorkflowActiveTab) => {
        this.setState((prevState) =>
            prevState.projectWorkflowActiveTab === projectWorkflowActiveTab
                ? null
                : { projectWorkflowActiveTab }
        );
    }

    setProjectWorkflowProceduresTab = (projectWorkflowProceduresTab) => {
        this.setState((prevState) =>
            prevState.projectWorkflowProceduresTab === projectWorkflowProceduresTab
                ? null
                : { projectWorkflowProceduresTab }
        );
    }

    resetProjectWorkflowTabs = () => {
        this.setState({ projectWorkflowActiveTab: 0, projectWorkflowProceduresTab: 'Enterprise' });
    }

    setFunctionMissingPrimaryStatus = (functionId, hasMissingPrimary) => {
        if (!functionId || !this._isMounted) {
            return;
        }

        this.setState((prevState, props) => {
            const currentValue = Boolean(prevState.functionsMissingPrimary[functionId]);

            if (hasMissingPrimary === currentValue) {
                return null;
            }

            const nextState = { ...prevState.functionsMissingPrimary };

            // If primary is now assigned, also check the function
            let updatedFunctions = undefined;
            if (!hasMissingPrimary) {
                delete nextState[functionId];
                // Try to auto-check the function in initialFunctionFormValues
                const selectedProjectOrGbu = (this.props && this.props.reduxStore && this.props.reduxStore.selectedProjectOrGbu) || {};
                if (Array.isArray(selectedProjectOrGbu.initialFunctionFormValues)) {
                    updatedFunctions = selectedProjectOrGbu.initialFunctionFormValues.map(fn => {
                        if (fn && fn.id === functionId && !fn.isChecked) {
                            return { ...fn, isChecked: true };
                        }
                        return fn;
                    });
                    // Save the updated functions to the store if any were changed
                    if (updatedFunctions.some((fn, idx) => fn !== selectedProjectOrGbu.initialFunctionFormValues[idx])) {
                        if (typeof this.saveProjectFunctions === 'function' && selectedProjectOrGbu.id) {
                            this.saveProjectFunctions({ functions: updatedFunctions, projectId: selectedProjectOrGbu.id });
                        }
                    }
                }
            } else {
                nextState[functionId] = true;
            }

            return {
                functionsMissingPrimary: nextState,
            };
        });
    };

    requiresPrimaryForStep(step, selectedProjectOrGbu, functionId) {
        if (!step || !selectedProjectOrGbu) {
            return false;
        }

        if (functionId === 0) {
            return true;
        }

        if (selectedProjectOrGbu.isGbu) {
            return step.stepScope === 'GBU' || step.stepScope === 'CORP';
        }

        return step.stepScope === 'PROJECT';
    }

    evaluateWorkflowForMissingPrimary({ workflowSteps, selectedProjectOrGbu, functionId }) {
        if (!Array.isArray(workflowSteps) || !workflowSteps.length) {
            return false;
        }

        return workflowSteps.some((step) => {
            if (!this.requiresPrimaryForStep(step, selectedProjectOrGbu, functionId)) {
                return false;
            }

            return !(step.primary && step.primary.bun);
        });
    }

    ensureFunctionPrimaryStatus = (functionId) => {
        const { selectedProjectOrGbu } = this.props.reduxStore;
        if (!functionId || !selectedProjectOrGbu) {
            return;
        }

        if (this.pendingPrimaryChecks[functionId]) {
            return;
        }

        this.pendingPrimaryChecks[functionId] = true;

        const webServices = new WebServices();

        const requestParams = {
            gbuId: selectedProjectOrGbu.isGbu ? selectedProjectOrGbu.id : null,
            projectId: selectedProjectOrGbu.isGbu ? null : selectedProjectOrGbu.id,
            functionId,
        };

        webServices.getProjectFunctionDetails(requestParams)
            .then((details) => {
                if (!details) {
                    return;
                }

                const workflowSteps = details.workflowSteps || [];
                const hasMissingPrimary = this.evaluateWorkflowForMissingPrimary({
                    workflowSteps,
                    selectedProjectOrGbu,
                    functionId,
                });

                if (this._isMounted) {
                    this.setFunctionMissingPrimaryStatus(functionId, hasMissingPrimary);
                }
            })
            .catch(() => {
                // Silent failure; do not block UI if details cannot be retrieved.
            })
            .finally(() => {
                delete this.pendingPrimaryChecks[functionId];
            });
    }

    syncPrimaryStatusForAssignedFunctions() {
        if (!this._isMounted) {
            return;
        }

        const selectedProjectOrGbu = this.props.reduxStore.selectedProjectOrGbu;

        if (!selectedProjectOrGbu) {
            if (this.assignedFunctionsSignature !== null) {
                this.assignedFunctionsSignature = null;
                this.setState((prevState) => {
                    const current = prevState.functionsMissingPrimary;
                    if (!current || !Object.keys(current).length) {
                        return null;
                    }
                    return { functionsMissingPrimary: {} };
                });
            }
            return;
        }

        if (selectedProjectOrGbu.isGbu) {
            if (this.assignedFunctionsSignature !== null) {
                this.assignedFunctionsSignature = null;
            }
            return;
        }

        const formValues = Array.isArray(selectedProjectOrGbu.initialFunctionFormValues)
            ? selectedProjectOrGbu.initialFunctionFormValues
            : [];

        const assignedFunctions = formValues.filter((fn) => fn && fn.isChecked && fn.id && fn.id !== 0);
        const signature = JSON.stringify(assignedFunctions.map((fn) => fn.id).sort());

        if (signature === this.assignedFunctionsSignature) {
            return;
        }

        this.assignedFunctionsSignature = signature;

        const activeIds = new Set(assignedFunctions.map((fn) => String(fn.id)));

        this.setState((prevState) => {
            const current = prevState.functionsMissingPrimary || {};
            const currentKeys = Object.keys(current);

            if (!currentKeys.length) {
                return null;
            }

            const filtered = currentKeys.reduce((acc, key) => {
                if (activeIds.has(key)) {
                    acc[key] = current[key];
                }
                return acc;
            }, {});

            if (Object.keys(filtered).length === currentKeys.length) {
                return null;
            }

            return { functionsMissingPrimary: filtered };
        });

        assignedFunctions.forEach((fn) => {
            this.ensureFunctionPrimaryStatus(fn.id);
        });
    }
   
    confirmGbuApproverUpdate = (formValues,gbuId) => {

        const originalSteps = this.props.reduxStore.selectedFunctionDetails.workflowSteps;

        const originalCorporateSteps = _.filter(originalSteps,{stepScope:'CORP'});
        const formCorporateSteps = _.filter(formValues.workflowSteps,{stepScope:'CORP'});
        const originalIWPPSteps = _.filter(originalSteps,{stepScope:'IWPP'});
        const formIWPPSteps = _.filter(formValues.workflowSteps,{stepScope:'IWPP'});

        const hasIWPPChanges = JSON.stringify(originalIWPPSteps) !== JSON.stringify(formIWPPSteps);
        const hasCorporateChanges = JSON.stringify(originalCorporateSteps) !== JSON.stringify(formCorporateSteps);

        
        if(hasIWPPChanges || hasCorporateChanges)
        {
            let confirmGbuApproversSubtitle = "";

            if (hasCorporateChanges) {
                confirmGbuApproversSubtitle = `${confirmGbuApproversSubtitle}You changed or removed corporate approvers. `;
            }

            if (hasIWPPChanges) {
                confirmGbuApproversSubtitle = `${confirmGbuApproversSubtitle}You changed or removed IWPP approvers. `;
            }

            this.setState({
                onConfirmGbuApprovers: () => {
    
                    this.setState({confirmGbuApproversDialogOpen:false,onConfirmGbuApprovers:null});
                    this.props.updateGbuWorkflowApprovers(formValues,gbuId);
                },
                confirmGbuApproversDialogOpen:true,
                confirmGbuApproversSubtitle
            });

        } else {

            this.props.updateGbuWorkflowApprovers(formValues,gbuId);

        }


    }

    componentDidMount() {
        this._isMounted = true;
        // Only fetch if data doesn't exist
        if (!this.props.reduxStore.gbus) {
            this.props.fetchProjects();
        }
        
        // If there's already a selected project, show the function list
        if (this.props.reduxStore.selectedProjectOrGbu) {
            this.setState({ changeDisplayFunctionList: true });
        }

        this.syncPrimaryStatusForAssignedFunctions();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.pendingPrimaryChecks = {};
    }

    componentDidUpdate(prevProps) {
        // If a project was selected and we're not already showing the function list, switch to it
        if (this.props.reduxStore.selectedProjectOrGbu && 
            !prevProps.reduxStore.selectedProjectOrGbu && 
            !this.state.changeDisplayFunctionList) {
            this.setState({ changeDisplayFunctionList: true });
        }
        
        // If project was deselected, go back to project list
        if (!this.props.reduxStore.selectedProjectOrGbu && 
            prevProps.reduxStore.selectedProjectOrGbu && 
            this.state.changeDisplayFunctionList) {
            this.setState({ changeDisplayFunctionList: false });
        }

        const selectedProjectOrGbu = this.props.reduxStore.selectedProjectOrGbu;
        const prevSelectedProjectOrGbu = prevProps.reduxStore.selectedProjectOrGbu;

        const prevProjectId = prevSelectedProjectOrGbu ? prevSelectedProjectOrGbu.id : null;
        const currentProjectId = selectedProjectOrGbu ? selectedProjectOrGbu.id : null;

        if (currentProjectId !== prevProjectId) {
            const updates = {};

            if (this.state.lastAutoOpenedFunctionId !== null) {
                updates.lastAutoOpenedFunctionId = null;
            }

            if (this.state.functionsMissingPrimary && Object.keys(this.state.functionsMissingPrimary).length) {
                updates.functionsMissingPrimary = {};
            }

            if (Object.keys(updates).length) {
                this.setState(updates);
            }
            this.assignedFunctionsSignature = null;
        }

        const selectedFunction = this.props.reduxStore.selectedFunction;
        const selectedFunctionDetails = this.props.reduxStore.selectedFunctionDetails;
        const functionId = selectedFunction && selectedFunction.id ? selectedFunction.id : null;
        const prevSelectedFunction = prevProps.reduxStore.selectedFunction;
        const prevFunctionId = prevSelectedFunction && prevSelectedFunction.id ? prevSelectedFunction.id : null;

        if (functionId !== prevFunctionId) {
            this.setState((prevState) => {
                const shouldResetActive = prevState.projectWorkflowActiveTab !== 0;
                const shouldResetProcedures = prevState.projectWorkflowProceduresTab !== 'Enterprise';

                if (!shouldResetActive && !shouldResetProcedures) {
                    return null;
                }

                return {
                    projectWorkflowActiveTab: 0,
                    projectWorkflowProceduresTab: 'Enterprise',
                };
            });
        }

        if (!functionId && this.state.lastAutoOpenedFunctionId !== null) {
            this.setState({ lastAutoOpenedFunctionId: null });
        }

        if (functionId && functionId !== 0 && selectedFunctionDetails && selectedFunctionDetails.id === functionId && this.state.lastAutoOpenedFunctionId !== functionId) {
            this.setState({ projectWorkflowDialogOpen: true, lastAutoOpenedFunctionId: functionId });
        }

        if (this.state.pendingFunctionSelections) {
            const storeSelections = this.props.reduxStore.selectedProjectOrGbu?.initialFunctionFormValues;
            if (storeSelections && _.isEqual(storeSelections, this.state.pendingFunctionSelections)) {
                this.clearPendingFunctionSelections();
            }
        }

        this.syncPrimaryStatusForAssignedFunctions();
    }

    render() {
        return (

            <ProjectsContext.Provider
                value={
                    {
                        ...this.state,
                        ...this.props,
                        closeWorkflowDialog:this.closeWorkflowDialog,
                        displayWorkflowDialog:this.displayWorkflowDialog,
                        displayAddProjectDialog:this.displayAddProjectDialog,
                        closeAddProjectDialog:this.closeAddProjectDialog,
                        editIWPPApprovers:this.editIWPPApprovers,
                        confirmDeleteOfIWPPAprroverStep:this.confirmDeleteOfIWPPAprroverStep,
                        confirmGbuApproverUpdate:this.confirmGbuApproverUpdate,
                        closeConfirmGbuApproversDialog:this.closeConfirmGbuApproversDialog,
                        displayFunctionList: this.displayFunctionList,
                        displayProjectCustomNameDialog:this.displayProjectCustomNameDialog,
                        closeProjectCustomNameDialog:this.closeProjectCustomNameDialog,
                        setPendingFunctionSelections: this.setPendingFunctionSelections,
                        clearPendingFunctionSelections: this.clearPendingFunctionSelections,
                        setWorkflowPendingChanges: this.setWorkflowPendingChanges,
                        setFunctionMissingPrimaryStatus: this.setFunctionMissingPrimaryStatus,
                        ensureFunctionPrimaryStatus:this.ensureFunctionPrimaryStatus,
                        setProjectWorkflowActiveTab:this.setProjectWorkflowActiveTab,
                        setProjectWorkflowProceduresTab:this.setProjectWorkflowProceduresTab,
                        resetProjectWorkflowTabs:this.resetProjectWorkflowTabs,
                        showSnackBarMessage: this.props.showSnackBarMessage,
                    }
                }>
                {this.props.children}
            </ProjectsContext.Provider>

        );
    }
}

const mapStateToProps = state => {
    const {projects,procedureManual} = state;
    return {procedureManual,reduxStore:projects, projects,contentHeight:state.app.contentSize.height,aboutCurrentUser:state.app.aboutCurrentUser};
}

ProjectsStore = connect(mapStateToProps,{importFunctionProcedureCategories,deleteIWPPApproverStep,updateIWPPWorkflowApprovers,importFunctionProcedures,fetchProjects,selectFunction,selectGbu,selectProject,editFunctions,saveProjectFunctions,addProject,updateGbuWorkflowApprovers,updateProjectWorkflowApprovers,updateProject,showSnackBarMessage})(ProjectsStore);

export {ProjectsStore};

export default ProjectsContext;